module.exports = __webpack_public_path__ + "img/curved7.32fb09df.jpg";